import DisplayShopName from '../common/DisplayShopName'
import ViewButton from '../common/ViewButton'
import DisplayActiveSuspended from './DisplayActiveSuspended'

const ShopTable = ({ data, onView }) => {
  return (
    <table className="min-w-full text-sm text-left text-gray-700">
      <thead className="bg-secondary-100 [&>th]:px-6 [&>th]:py-4 [&>th]:font-medium [&>th]:text-black [&>th]:text-base">
        <tr>
          <th className="px-6 py-3">Shop Name</th>
          <th className="px-6 py-3">Building Name</th>
          <th className="px-6 py-3">Floor</th>
          <th className="px-6 py-3">Shop Number</th>
          <th className="px-6 py-3">Status</th>
          <th className="px-6 py-3">Actions</th>
        </tr>
      </thead>
      <tbody className="text-base font-fontFamily">
        {data.length > 0 ? (
          data.map((item, index) => (
            <tr
              key={item.userId || index}
              className={`border-b ${index % 2 === 0 ? 'bg-background' : 'bg-background-muted'}`}
            >
              <td className="px-6 py-4">
                <DisplayShopName
                  shop={{
                    name: item.shopName,
                    isPremium: item.isPremium,
                    isVerified: item.isApproved,
                  }}
                />
              </td>
              <td className="px-6 py-4">{item.buildingName || '—'}</td>
              <td className="px-6 py-4">{item.floor || '—'}</td>
              <td className="px-6 py-4">{item.shopNumber || '—'}</td>
              <td className="px-6 py-4 font-medium">
                <div className="flex gap-2">
                  <DisplayActiveSuspended
                    isActive={item.user?.isActive}
                    suspendedBy={item.user?.suspendedBy}
                  />
                </div>
              </td>
              <td className="px-6 py-4">
                <ViewButton redirectPath={onView(item.shopSlug)} />
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
              No shops found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default ShopTable
